/* Jhilke Studio — desktop click-to-zoom for the fullscreen product gallery.
   The fullscreen (zoom) dialog fits each image to the screen (see
   jhilke-gallery.css). On desktop: click the image to zoom in, move the mouse
   to pan, click again to zoom back to fit. Thumbnails on the side navigate
   normally; the X / Esc close. Mobile keeps the theme's native pinch-to-zoom.
   Keyboard (roadmap DO, 2026-10-08): each image in the dialog takes focus; Enter or Space zooms in and
   out, the arrow keys move around while zoomed. */
(function () {
  'use strict';
  try {
    var DESKTOP = window.matchMedia('(min-width: 750px)');
    var ZOOM = 2.2;
    var CONTAINER = '.dialog-zoomed-gallery .product-media-container--image';

    function setOrigin(img, x, y) {
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      img.style.setProperty('--jz-ox', Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100)) + '%');
      img.style.setProperty('--jz-oy', Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100)) + '%');
    }

    function unzoomAll(scope) {
      (scope || document).querySelectorAll(CONTAINER + '.jhilke-zoomed').forEach(function (c) {
        c.classList.remove('jhilke-zoomed');
        if (c.hasAttribute('data-jz-key')) c.setAttribute('aria-pressed', 'false');
        var img = c.querySelector('.product-media__image');
        if (img) img.style.removeProperty('--jz-scale');
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        if (!DESKTOP.matches) return;
        var t = e.target;
        if (!t || !t.closest) return;
        var dialog = t.closest('.dialog-zoomed-gallery__dialog');
        if (!dialog) return; // not in fullscreen

        // Thumbnails: let the theme navigate, just clear any zoom first.
        if (t.closest('.dialog-thumbnails-list__thumbnail')) {
          unzoomAll(dialog);
          return;
        }
        // Close button: let the theme close it.
        if (t.closest('.dialog-zoomed-gallery__close-button')) return;

        // Click on the image itself -> toggle zoom (never close).
        var img = t.closest('.product-media__image');
        var container = t.closest(CONTAINER);
        if (img && container) {
          e.preventDefault();
          e.stopPropagation();
          var nowZoomed = container.classList.toggle('jhilke-zoomed');
          if (container.hasAttribute('data-jz-key')) container.setAttribute('aria-pressed', nowZoomed ? 'true' : 'false');
          if (nowZoomed) {
            img.style.setProperty('--jz-scale', String(ZOOM));
            setOrigin(img, e.clientX, e.clientY);
          } else {
            img.style.removeProperty('--jz-scale');
          }
        }
        // Any other click (empty area) is ignored — X or Esc closes.
      },
      true
    );

    document.addEventListener('mousemove', function (e) {
      if (!DESKTOP.matches) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var container = t.closest(CONTAINER + '.jhilke-zoomed');
      if (!container) return;
      var img = container.querySelector('.product-media__image');
      if (img) setOrigin(img, e.clientX, e.clientY);
    });

    // Keyboard: make the dialog's images reachable with Tab, then Enter/Space and the arrow keys.
    function prepare(dialog) {
      dialog.querySelectorAll(CONTAINER).forEach(function (c) {
        if (c.hasAttribute('data-jz-key')) return;
        c.setAttribute('data-jz-key', '');
        c.tabIndex = 0;
        c.setAttribute('role', 'button');
        c.setAttribute('aria-pressed', c.classList.contains('jhilke-zoomed') ? 'true' : 'false');
        c.setAttribute('aria-label', 'Zoom image. While zoomed, use the arrow keys to look around');
      });
    }
    function setZoom(container, on) {
      var img = container.querySelector('.product-media__image');
      if (!img) return;
      container.classList.toggle('jhilke-zoomed', on);
      container.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) {
        img.style.setProperty('--jz-scale', String(ZOOM));
        img.style.setProperty('--jz-ox', '50%');
        img.style.setProperty('--jz-oy', '50%');
      } else {
        img.style.removeProperty('--jz-scale');
      }
    }
    document.addEventListener('focusin', function (e) {
      if (!DESKTOP.matches) return;
      var dialog = e.target && e.target.closest && e.target.closest('.dialog-zoomed-gallery__dialog');
      if (dialog) prepare(dialog);
    });
    document.addEventListener('keydown', function (e) {
      if (!DESKTOP.matches) return;
      var container = e.target && e.target.matches && e.target.matches(CONTAINER) ? e.target : null;
      if (!container) return;
      var zoomed = container.classList.contains('jhilke-zoomed');
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setZoom(container, !zoomed);
        return;
      }
      var step = { ArrowLeft: [-8, 0], ArrowRight: [8, 0], ArrowUp: [0, -8], ArrowDown: [0, 8] }[e.key];
      if (!step || !zoomed) return;
      e.preventDefault();
      e.stopPropagation(); // panning, not changing slide
      var img = container.querySelector('.product-media__image');
      if (!img) return;
      var ox = parseFloat(img.style.getPropertyValue('--jz-ox')) || 50;
      var oy = parseFloat(img.style.getPropertyValue('--jz-oy')) || 50;
      img.style.setProperty('--jz-ox', Math.min(100, Math.max(0, ox + step[0])) + '%');
      img.style.setProperty('--jz-oy', Math.min(100, Math.max(0, oy + step[1])) + '%');
    });

    window.addEventListener('dialog:close', function () { unzoomAll(document); });
  } catch (err) {
    /* fail silently — never block the page */
  }
})();
